import theme from '../../themes/green';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'row',
    height: 30,
    flex: '0 0 30px',
    backgroundColor: theme.pallete.lightBackground,
    transition: theme.transitions.fast,
    alignItems: 'center',
    position: 'relative',
    zIndex: 2,
  },
  activeStyle: {
    backgroundColor: theme.pallete.background,
    color: 'red',
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/components/AccessoryToolbar/styles.js